/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DevCodeIcon16Regular = forwardRef('DevCodeIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M10.47 2.21a.75.75 0 1 0-1.44-.42l-3.5 12a.75.75 0 1 0 1.44.42l3.5-12Z" }),
        React.createElement("path", { d: "M4.28 3.97a.75.75 0 0 1 0 1.06L1.63 7.682a.45.45 0 0 0 0 .636L4.28 10.97a.75.75 0 1 1-1.06 1.06L.568 9.38a1.95 1.95 0 0 1 0-2.758L3.22 3.97a.75.75 0 0 1 1.06 0Z" }),
        React.createElement("path", { d: "M11.72 3.97a.75.75 0 0 1 1.06 0l2.652 2.651a1.95 1.95 0 0 1 0 2.758L12.78 12.03a.75.75 0 0 1-1.06-1.06l2.651-2.652a.45.45 0 0 0 0-.636L11.72 5.03a.75.75 0 0 1 0-1.06Z" })));
});
